import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import GradingMachineListActions, {
  GradingMachineTypes
} from '../Stores/GradingMachineList/Actions';

const getAppStore = state => state.app;

export function* gradingMachineListFetchList({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(GradingMachineListActions.gradingMachineListFetchListLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gradingMachine/indexProcess`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        GradingMachineListActions.gradingMachineListFetchListSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GradingMachineListActions.gradingMachineListFetchListLoading(false));
  }
}

export function* gradingMachineListGoToResource({ resId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/gradingMachine/update/${resId}/GENERAL`));
}

export function* gradingMachineListGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/GRADING_MACHINE/${hdrId}/Item`));
}

export function* gradingMachineListNewResource() {
  const app = yield select(getAppStore);
  const itemType = 1; // STOCK_ITEM
  yield put(push(`${app.appPath}/gradingMachine/create/${itemType}/GENERAL`));
}

export const saga = [
  takeLatest(GradingMachineTypes.GRADING_MACHINE_LIST_FETCH_LIST, gradingMachineListFetchList),
  takeLatest(GradingMachineTypes.GRADING_MACHINE_LIST_GO_TO_AUDIT, gradingMachineListGoToAudit),
  takeLatest(
    GradingMachineTypes.GRADING_MACHINE_LIST_GO_TO_RESOURCE,
    gradingMachineListGoToResource
  ),
  takeLatest(GradingMachineTypes.GRADING_MACHINE_LIST_NEW_RESOURCE, gradingMachineListNewResource)
];
